<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="400"
  >
    <v-card>
      <v-card-title>
        <span>
          {{ $t('domains.dialog.title') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="items"
                v-model="status"
                :label="$t('domains.table.status')"
                v-validate="'required'"
                :error-messages="errors.collect($t('domains.table.status'))"
                :data-vv-name="$t('domains.table.status')"
                required
                item-text="name"
                item-value="value"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="$emit('close')"
        >
          {{ $t('domains.dialog.cancel') }}
        </v-btn>
        <v-btn
          @click="save"
          color="primary"
        >
          {{ $t('domains.dialog.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['dialog'],
  data() {
    return {
      status: null,
      items: [
        { name: this.$t('domains.statuses.active'), value: 'active' },
        { name: this.$t('domains.statuses.inactive'), value: 'inactive' },
        { name: this.$t('domains.statuses.pending_for_delete'), value: 'pending_for_delete' }
      ]
    }
  },
  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        this.$emit('confirm', this.status)
      }
    }
  }

}
</script>

<style>

</style>